export class AlertScheduleModel {
    cronExpression = null;
    timezone = 'UTC';
}
//# sourceMappingURL=alert-schedule.js.map